export function isRouteActive(route: string, currentRoute: string): boolean {
    return currentRoute.includes(route);
}
